// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const APP_VERSION = {
  "buildDateUTC": "Fri, 26 Jun 2026 00:18:15 GMT",
  "packageVersion": "5.6.3",
  "commitSha": "201e55dc44bc95493782ec880860b5d7cc9ce900",
  "branch": "kemal/ne-17524-recording-autostop-fix"
};
/* eslint:enable */